import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import OrderIdHelp from '../OrderIdHelp/OrderIdHelp'
import * as Styles from './styles'

const UrlParametersTable = ({ storeProvider }) => {
  const { t } = useTranslation()

  return (
    <Styles.Table>
      <tbody>
        <tr>
          <Styles.Name scope="row">
            <Text type="bodySMedium">order_id</Text>
          </Styles.Name>
          <Styles.Description>
            <OrderIdHelp storeProvider={storeProvider} />
          </Styles.Description>
        </tr>
        <tr>
          <Styles.Name scope="row">
            <Text type="bodySMedium">email</Text>
          </Styles.Name>
          <Styles.Description>
            <Text type="bodySRegular">
              {t(
                'El email del cliente, como segunda validación. El ID de pedido solo no basta. Verificamos que ambos coincidan antes de mostrar nada.'
              )}
            </Text>
          </Styles.Description>
        </tr>
        <tr>
          <Styles.Name scope="row">
            <Text type="bodySMedium">language</Text>
          </Styles.Name>
          <Styles.Description>
            <Text type="bodySRegular">
              {t(
                'El idioma en el que se muestra la página, sin depender del navegador del cliente. Valores aceptados: es, en, fr, it, de, pt, nl, ko.'
              )}
            </Text>
          </Styles.Description>
        </tr>
      </tbody>
    </Styles.Table>
  )
}

export default UrlParametersTable
